import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { FolderKanban, ShieldCheck, ChevronRight } from "lucide-react";

export function usePersonProjects(personId) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/projects", { params: { person_id: personId } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, [personId]);
  return items;
}

export function PersonProjectsPanel({ items }) {
  const navigate = useNavigate();
  if (!items.length) return <p className="text-sm text-slate-500 p-4" data-testid="person-projects-empty">No projects yet. A Career Conversion project is created automatically when this person is enrolled in a program.</p>;
  return (
    <div className="space-y-2 p-1" data-testid="person-projects">
      {items.map((p) => (
        <button key={p.id} onClick={() => navigate(`/projects/${p.id}`)} data-testid={`person-project-${p.id}`}
          className={`w-full text-left rounded-xl border p-4 flex items-center gap-3 hover:shadow-sm transition-shadow ${p.system_managed ? "border-[#006090]/30 bg-[#006090]/[0.04]" : "border-slate-200 bg-white"}`}>
          <span className={`w-9 h-9 grid place-items-center rounded-lg ${p.system_managed ? "bg-[#006090] text-white" : "bg-slate-100 text-slate-500"}`}>
            {p.system_managed ? <ShieldCheck className="w-4 h-4" /> : <FolderKanban className="w-4 h-4" />}
          </span>
          <div className="min-w-0 flex-1">
            <p className="font-semibold text-sm text-slate-900">{p.name}{p.system_managed && p.program_label ? ` · ${p.program_label}` : ""}</p>
            <p className="text-xs text-slate-500">{p.system_managed ? "System-managed program project" : "Created by the candidate"} · {p.stats?.completed_tasks || 0}/{p.stats?.total_tasks || 0} tasks complete</p>
          </div>
          <ChevronRight className="w-4 h-4 text-slate-400" />
        </button>
      ))}
    </div>
  );
}
